import React from 'react';
import './TableSkeleton.scss';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  className?: string;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ 
  rows = 5, 
  columns = 6, 
  className = '' 
}) => {
  return (
    <div className={`table-skeleton ${className}`}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="skeleton-row">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div 
              key={colIndex} 
              className={`skeleton-cell skeleton-cell--${colIndex % 3}`}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
